<template>
  <div class="form_step-2 form_step form-scroll">
    <form id="step2" @submit.prevent="" method="post">
      <div class="popup-title" v-if="!responseStatus">{{__t('Підтвердіть номер телефону')}}</div>
      <div class="popup-title" v-else>{{__t('Введіть код з СМС')}}</div>

      <div class="popup-description" v-if="!responseStatus">
        <p>{{__t('Ми вислали код підтверження на номер')}} <span>{{phone}}</span></p>
        <p>{{__t('Введіть шестизначний код в поле')}}</p>
      </div>
      <div class="popup-error" v-if="messageError">
        <p ref="error_responce" v-html="messageError"></p>
      </div>
      <div class="popup-inputs">
        <div class="buttons-group fw" :class="isEror">
          <input class="buttons-group_btn" max="9" type="tel" pattern="[0-9]"
                 name="code1"
                 ref="code1"
                 v-model="code1"
                 @keyup.delete="backInput($event)"
                 :disabled="responseStatus == 'error' || responseStatus == 'fatalError'"
          >
          <input class="buttons-group_btn" max="9" type="tel" pattern="[0-9]"
                 name="code2"
                 ref="code2"
                 v-model="code2"
                 @keyup.delete="backInput($event)"
                 :disabled="responseStatus == 'error' || responseStatus == 'fatalError'"
          >
          <input class="buttons-group_btn" max="9" type="tel" pattern="[0-9]"
                 name="code3"
                 ref="code3"
                 v-model="code3"
                 @keyup.delete="backInput($event)"
                 :disabled="responseStatus == 'error' || responseStatus == 'fatalError'"
          >
          <input class="buttons-group_btn" max="9" type="tel" pattern="[0-9]"
                 name="code4"
                 ref="code4"
                 v-model="code4"
                 @keyup.delete="backInput($event)"
                 :disabled="responseStatus == 'error' || responseStatus == 'fatalError'"
          >

          <input class="buttons-group_btn" max="9" type="tel" pattern="[0-9]"
                 name="code5"
                 ref="code5"
                 v-model="code5"
                 @keyup.delete="backInput($event)"
                 :disabled="responseStatus == 'error' || responseStatus == 'fatalError'"
          >

          <input class="buttons-group_btn" max="9" type="tel" pattern="[0-9]"
                 name="code6"
                 ref="code6"
                 v-model="code6"
                 @keyup.delete="backInput($event)"
                 :disabled="responseStatus == 'error' || responseStatus == 'fatalError'"
          >

        </div>

        <div class="popup-tryAgain" v-if="!responseStatus">
          <span>{{__t('Не отримали код?')}}</span>
          <button type="button" class="popup-link" @click="reSendCode()">{{__t('Запросити код повторно')}}</button>
        </div>
      </div>

      <div class="button-group">
        <button type="button"
                v-if="!responseStatus"
                @click.submit.prevent="goBack"
                class="popup-button btn green-btn colored-btn">
          {{__t('Змінити номер')}}
        </button>
        <button type="submit" class="popup-button btn violet-btn" v-if="!responseStatus">
          {{__t('Підтвердити')}}
        </button>
      </div>

      <button type="button" class="popup-button btn violet-btn" v-if="responseStatus == 'error'"
              @click.submit.prevent="getNewPass()">
        {{__t('Запросити новий пароль')}}
      </button>
      <button type="button" class="popup-button btn violet-btn" v-if="responseStatus == 'fatalError'"
              @click="fatalEvent">
        {{__t('Завершити')}}
      </button>
    </form>
  </div>
</template>

<script>

    export default {
        name: 'step2',
        props: [
            "phone"
        ],
        data() {
            return {
                isEror: '',
                errorValidation: {},
                code1: '',
                code2: '',
                code3: '',
                code4: '',
                code5: '',
                code6: '',
                messageError: '',
                responseStatus: ''
            }
        },
        computed: {

            codefull: function () {
                return this.code1 + this.code2 + this.code3 + this.code4 + this.code5 + this.code6;
            },

        },

        watch: {
            code1: function (val) {
                if (val) {
                    this.code1 = val.replace(/\D+/g, "")[0];
                }
                if (this.code1.length) {
                    this.$refs.code2.focus();
                }
            },
            code2: function (val) {
                if (val) {
                    this.code2 = val.replace(/\D+/g, "")[0];
                }
                if (this.code2.length) {
                    this.$refs.code3.focus();
                }
            },

            code3: function (val) {
                if (val) {
                    this.code3 = val.replace(/\D+/g, "")[0];
                }
                if (this.code3.length) {
                    this.$refs.code4.focus();
                }
            },

            code4: function (val) {
                if (val) {
                    this.code4 = val.replace(/\D+/g, "")[0];
                }
                if (this.code4.length) {
                    this.$refs.code5.focus();
                }
            },

            code5: function (val) {
                if (val) {
                    this.code5 = val.replace(/\D+/g, "")[0];
                }
                if (this.code5.length) {
                    this.$refs.code6.focus();
                }
            },
            code6: function (val) {
                if (val) {
                    this.code6 = val.replace(/\D+/g, "")[0];
                }
            },
        },

        methods: {
            __t(phrase) {
                return window.__t(phrase);
            },
            getNewPass() {
                this.messageError = '';
                this.clearFieldsCode();
                this.responseStatus = '';
                this.$refs.code1.focus();
                this.reSendCode();


            },
            backInput(e) {
                let behind = e.target.previousElementSibling;
                if (behind) {
                    behind.focus();
                }
            },
            clearFieldsCode() {
                this.code1 = '';
                this.code2 = '';
                this.code3 = '';
                this.code4 = '';
                this.code5 = '';
                this.code6 = '';
            },

            setFocus(val, field1, field2) {
                field1 = val.replace(/\D+/g, "");

                this.field1 = field1;

                if (field1.length) {
                    field2.focus();
                }
            },

            reSendCode() {

                var self = this;

                jQuery.ajax({
                  headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                  },
                    type: "POST",
                    url: '/cash/re-send-code',
                    cache: false,
                    dataType: "json",
                    success: function (response) {

                    },
                    error: function (error) {
                        self.errorValidation = error.responseJSON;
                    }
                });
            },

            goBack() {
                this.$emit('goback');
                this.clearFieldsCode();
                return false;
            },

            goNext() {
                this.$emit('gonext');
                return false;
            },
            fatalEvent() {
                this.$emit('fatalEvent');
                this.goBack();
            },

            validation: function () {

                var self = this;

                $('#step2').validate({
                    rules: {
                        code1: "required",
                        code2: "required",
                        code3: "required",
                        code4: "required",
                        code5: "required",
                        code6: "required",
                    },
                    messages: {
                        code1: {
                            required: '',
                        },
                        code2: {
                            required: '',
                        },
                        code3: {
                            required: '',
                        },
                        code4: {
                            required: '',
                        },
                        code5: {
                            required: '',
                        },
                        code6: {
                            required: '',
                        }
                    },
                    errorPlacement: function (error, element) {

                    },
                    submitHandler: function (form) {
                        self.$emit('openPreloader');
                        var data = {
                            'code': self.codefull,
                            'landing_type': "cash"
                        };

                        jQuery.ajax({
                          headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                          },
                            data: data,
                            type: "POST",
                            url: '/cash/step2',
                            cache: false,
                            dataType: "json",
                            success: function (response) {
                                self.$emit('closePreloader');

                                if (response.status === "error" || response.status === "fatalError") {
                                    self.messageError = response.message;
                                    self.responseStatus = response.status;

                                    return;
                                }

                                self.goNext();
                            },
                            error: function (error) {
                                console.log(error);
                                self.errorValidation = error.responseJSON;
                                self.clearFieldsCode();
                                self.$emit('closePreloader');
                            }
                        });
                    }
                });
            },
        },

        mounted: function () {
            this.validation();
            this.$refs.code1.focus();
        }
    }

</script>
